import { cn } from "@cliently/ui";

const RULES: Array<{ key: string; label: string; test: (p: string) => boolean }> = [
  { key: "len", label: "12 caractères minimum", test: (p) => p.length >= 12 },
  { key: "upper", label: "Au moins une majuscule", test: (p) => /[A-Z]/.test(p) },
  { key: "lower", label: "Au moins une minuscule", test: (p) => /[a-z]/.test(p) },
  { key: "digit", label: "Au moins un chiffre", test: (p) => /\d/.test(p) },
  { key: "sym", label: "Au moins un caractère spécial", test: (p) => /[^A-Za-z0-9]/.test(p) },
];

export const PasswordStrengthHints = ({ password }: { password: string }) => {
  if (!password) return null;
  return (
    <ul className="mt-2 space-y-1 text-xs">
      {RULES.map((rule) => {
        const ok = rule.test(password);
        return (
          <li
            key={rule.key}
            className={cn(
              "flex items-center gap-1.5",
              ok ? "text-emerald-600" : "text-muted-foreground",
            )}
          >
            <span aria-hidden>{ok ? "✓" : "○"}</span>
            <span>{rule.label}</span>
          </li>
        );
      })}
    </ul>
  );
};
